//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import work_bench_item from "@/components/work_bench_item";
import WxjsSdk from "@/Manager/10.Tms/ProductSnManager";
import "@/assets/css/reset.css";
import "@/assets/css/global.css";

export default {
  components: { work_bench_item },
  data() {
    return {
      passageUser: {},
      actionTitle: "",
      actionList: [],
      showActionSheet: false,
      actionSheet1: {
        title: "选择盘库方式",
        actions: [
          {
            name: "1.直接扫码盘库",
            url: "http://ysl.entfly.com/mDms/DealerStockCheckOrder/Scan"
          },
          {
            name: "2.分次扫码盘库",
            url: "http://ysl.entfly.com/mDms/SubStockOrder/Index?from=home"
          },
          {
            name: "3.多人扫码盘库",
            url: "http://ysl.entfly.com/mDms/SubStockOrder2/Index?from=home"
          }
        ]
      },
      work_bench_item1: [
        {
          img: "images/1_15.png",
          text: "销售区域",
          link: "http://ysl.entfly.com/mCm/SalesArea"
        },
        {
          img: "images/1_19.png",
          text: "销售人员",
          link: "http://ysl.entfly.com/mCm/SalesUser"
        }
      ],
      work_bench_item2: [
        {
          img: "images/1_23.png",
          text: "经销商列表",
          link: this.$api.host + "/mCm/SalesDealer"
        },
        {
          img: "images/3_06.png",
          text: "经销商库存",
          link: this.$api.host + "/mCm/DealerStockData/DealerIndex"
        }
      ],
      work_bench_item3: [
        {
          img: "images/3_03.png",
          text: "门店列表",
          link: this.$api.host + "/mCm/SalesShop",
          hide_border: true
        },
        {
          img: "images/31_11.png",
          text: "门店库存",
          link: this.$api.host + "/mCm/ShopStockData/ShopIndex"
        }
      ],
      work_bench_item4: [
        {
          img: "images/31_07.png",
          text: "我的金额",
          link: this.$api.host + "/mCc/PassageUserCashInOrder/Index"
        },
        {
          img: "images/31_11.png",
          text: "金额记录",
          link: this.$api.host + "/mCc/PassageUserCashDataLog/Index"
        }
      ],
      work_bench_item5: [
        {
          img: "images/20_03.png",
          text: "会员列表",
          link: this.$api.host + "/mCM/Member/Index?from=home"
        },
        {
          img: "images/3_10.png",
          text: "活动列表",
          link: this.$api.host + "/mCM/NewCustomerActivity/Index?from=home"
        }
      ]
    };
  },
  computed: {},

  created() {
    this.wxJsSdk();
    this.$wx.initConfig();

    var urlPassUser =  this.$appBox.getPassageUser()
    if(urlPassUser == null) {
      this.passageUser = ''
    } else {
      this.passageUser = this.$appBox.getPassageUser();
    }

    console.log(this.passageUser, "this.passageUser++++++");
    // this.$http({
    //   url: this.$api.GetPassageUserInfo,
    //   method: "post"
    // }).then(res => {
    //   if (res.data.state == 1) {
    //     this.pageData = res.data.data;
    //   }
    // });
  },

  methods: {
    // 获取jssdk
    wxJsSdk() {
      console.log(window.location.href, "location.origin");
      var sdkData = {
        uOpenId: "8659662804444e4b9ff929bb78b3da21",
        url: window.location.href
      };
      WxjsSdk.wxJsSdk(sdkData).then(res => {
        this.$msg.hideLoading();
        wx.config({
          debug: false, // true,// 开启调试模式
          appId: res.appId, // 必填，公众号的唯一标识
          timestamp: res.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.nonceStr, // 必填，生成签名的随机串
          signature: res.signature, // 必填，签名，见附录1
          // 必填，需要使用的JS接口列表
          jsApiList: ["scanQRCode"]
        });
      });
    },
    goGuideRightsPage() {
      this.$router.push("/mGms/guideRights");
    },
    goPage(link) {
      if (link) {
        // wx.navigateTo({ url: link })
        if (link.indexOf("http") == -1) {
          this.$router.push(link);
        } else {
          window.location = link;
          this.$toast({
            type: "loading",
            duration: 0, // 持续展示 toast
            forbidClick: true, // 禁用背景点击
            loadingType: "spinner",
            message: "加载中"
          });
        }
      }
    },
    stockCount() {
      this.showActionSheet = true;
      this.actionTitle = this.actionSheet1.title;
      this.actionList = this.actionSheet1.actions;
    },
    onSelect(item) {
      console.log(item);
      if (item.url) {
        if (item.url.indexOf("http") == -1) {
          this.$router.push(item.url);
        } else {
          window.location = item.url;
          this.$toast({
            type: "loading",
            duration: 0, // 持续展示 toast
            forbidClick: true, // 禁用背景点击
            loadingType: "spinner",
            message: "加载中"
          });
        }
      }
    },
    onClickScanBtn() {
      wx.scanQRCode({
        needResult: 0,
        scanType: ["qrCode"],
        success: res1 => {
          console.log("开始扫码", res1);
        },
        fail: err => this.err_toast(err)
      });
    }
  }
};
